/**
 * Laravel style translations
 * @param key
 * @param replace
 */
export default function trans(key, replace = {}) {
    let translation = Lang[key] || null;

    for (let placeholder in replace) {
        translation = translation.replace(`:${placeholder}`, replace[placeholder]);
    }

    return translation;
}
